import { useSuspenseQuery } from '@tanstack/react-query';

import { PublicationImpactFactor } from '@/module/Journal/components/PublicationImpactFactor';

import { Id } from '@feature/utils';

import { getAbstractImpactFactorOptions } from '../model/AbstractQuery';

interface AbstractImpactFactorProps {
  abstractId: Id;
  hideTemporary?: boolean;
}

export function AbstractImpactFactor({ abstractId, hideTemporary }: AbstractImpactFactorProps) {
  const { data } = useSuspenseQuery(getAbstractImpactFactorOptions(abstractId));

  return (
    <PublicationImpactFactor
      hideTemporary={hideTemporary}
      data={data}
    />
  );
}
